import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import { Fields } from 'redux-form';

import ProductClaimDeliveryFields from 'components/workflow/ProductClaim/ProductClaimDeliveryFields';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

const styles = theme => ({
  deliveryFields: {
    marginTop: -7,
    marginLeft: -4,
    marginRight: -4,
  },
});

const OrdersTableRowItemDelivery = ({
  namePrefix,
  disabled,
  change,
  className,
  actions,
  variant,
  classes,
}) => (
  <Fields
    className={classes.deliveryFields}
    names={[
      `${namePrefix}.Driver Name`,
      `${namePrefix}.Selected Driver Name`,
      `${namePrefix}.Driver ID`,
      `${namePrefix}.Place of SRV`,
      `${namePrefix}.Date of Delivery`,
      `${namePrefix}.Time of Delivery`,
    ]}
    name={namePrefix}
    nameKeys={{
      driverID: 'Driver ID',
      driverName: 'Driver Name',
      selectedDriverName: 'Selected Driver Name',
      placeOfSRV: 'Place of SRV',
      dateOfDelivery: 'Date of Delivery',
      timeOfDelivery: 'Time of Delivery',
    }}
    component={ProductClaimDeliveryFields}
    disabled={disabled}
    variant={variant}
  />
);

OrdersTableRowItemDelivery.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

OrdersTableRowItemDelivery.defaultProps = {
  className: '',
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(OrdersTableRowItemDelivery),
);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemDelivery.js